import React from 'react'

import SwiperCore from 'swiper'

import { Swiper, SwiperSlide } from 'swiper/react'

import { StoryClientType } from 'src/strapi/types/storiesTypes'

import { RecommendedSliderSlide } from './RecommendedSliderSlide/RecommendedSliderSlide'

export type StoryRecommendedSliderProps = {
  stories: Array<StoryClientType>
  onSwiper: (swiper: SwiperCore) => void
}

export const StoryRecommendedSlider: React.FC<StoryRecommendedSliderProps> = ({
  stories,
  onSwiper,
}) => {
  return (
    <Swiper
      slidesPerView="auto"
      breakpoints={{
        0: {
          slidesPerView: 1,
          spaceBetween: 32,
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
        1080: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      }}
      onSwiper={onSwiper}
      mousewheel={{
        forceToAxis: true,
        sensitivity: 5,
      }}
      loop={stories.length > 3}
      updateOnWindowResize
    >
      {stories.map((story, i) => (
        <SwiperSlide key={i}>
          <RecommendedSliderSlide key={i} {...story} />
        </SwiperSlide>
      ))}
    </Swiper>
  )
}
